var Aneox;
(function (Aneox) {
  'use strict';

  var Wines = (function () {

    var animations;
    var locale;
    var scroll;
    var router;

    var winePageElement;
    var wineBottleElement;
    var wineDetailsElement;
    var wineDownloadButton
    var wineWrapper;
    var wineNameLeads = [
      'Bourgogne',
      'Meursault',
      'Saint-Aubin',
      'Puligny-Montrachet',
      'Crémant de Bourgogne',
      'Pommard',
      'Volnay'
    ];
    var wineNameSubleads = [
      '1er Cru',
      'Aligoté',
      'Rouge'
    ];
    var wineNameRegex = new RegExp('(' + wineNameLeads.join('|') + ')' + 
      '( ' + wineNameSubleads.join(' | ') + ' | )(.*)');

    var wineIds;
    var currentWineIndex;
      
    function Wines(anims, lang, scrolling, routing) {
     
      animations = anims;
      locale = lang;
      scroll = scrolling;
      router = routing;

      winePageElement = $('#wine');
      wineBottleElement = winePageElement.find('#wine-bottle');
      wineDetailsElement = winePageElement.find('#wine-details');
      wineDownloadButton = $('#wine-download-button');
      wineWrapper = $('#wine-wrapper');

      /*var whites = _.filter(Aneox.Data.Data.wines, { type: 'white' });
      //console.log(Aneox.App.dataWhiteWines);
        //var whites = Aneox.App.dataWhiteWines;
      var fragment = $(document.createDocumentFragment());
      whites.forEach(function(wine) {
        fragment.append('<li class="wine-li"><a router-href="' + wine.id + '">' +
          wine.name + '</a></li>');
      });
      $('#wines-white').append(fragment);

      var reds = _.filter(Aneox.Data.Data.wines, { type: 'red' });
      //var reds = app.dataRedWines;
      fragment = $(document.createDocumentFragment());
      reds.forEach(function(wine) {
        fragment.append('<li class="wine-li"><a router-href="' + wine.id + '">' +
          wine.name + '</a></li>');
      });
      $('#wines-red').append(fragment);*/
    }
      
      
    Wines.prototype.setWinesList = function(locale){

      wineIds = _.map(app.dataAllWines, 'id');
    
      var whites = _.filter(app.dataWhiteWines, {locale: locale});
      var fragment = $(document.createDocumentFragment());
      whites.forEach(function(wine) {
        fragment.append('<li class="wine-li"><a router-href="' + wine.localeNid + '">' +
          wine.name + '</a></li>');
      });
      $('#wines-white').empty().append(fragment);

      var reds = _.filter(app.dataRedWines, {locale: locale});
      fragment = $(document.createDocumentFragment());
      reds.forEach(function(wine) {
        fragment.append('<li class="wine-li"><a router-href="' + wine.localeNid + '">' +
          wine.name + '</a></li>');
      });
      $('#wines-red').empty().append(fragment);
    }

    Wines.prototype.openPage = function(id) {
      currentWineIndex = wineIds.indexOf(id);

      scroll.incrementScrollRetainCount();
      populatePage(id);
      animations.openOverlay(winePageElement);
      new TimelineMax()
      .add(animations.PageBorderTimeline($('#wine-borders')), 2)
      .from('#wine-page-img', 1, {
        scale: 1.1
      }, 2)
      .from('#wine-bottle', 1.5, {
        y: '120%',
        ease: Expo.easeOut
      }, 3)
      .add(animations.SubtitleTimeline($('#wine-title')), 2.5)
      .add(animations.TextTimeline($('#wine-intro')), 2.7)
      .staggerFrom('#wine-details dt', .5, {
        opacity: 0
      }, .1, 2.9)
      .staggerFrom('#wine-details dd', .5, {
        opacity: 0
      }, .1, 2.9);
    };

    Wines.prototype.closePage = function() {
      setPage('wines');
      animations.closeOverlay(winePageElement, emptyPage);
      scroll.setManualScroll().decrementScrollRetainCount();
    }

    Wines.prototype.handleWindowResize = function(bodyWidth, bodyHeight) {
      winePageElement.mousemove(function(event) {
        var fgX = (bodyWidth / 2 - event.clientX) / 200;
        var fgY = (bodyHeight / 2 - event.clientY) / 200;
        var bgX = (bodyWidth / 2 + event.clientX) / 500;
        var bgY = (bodyHeight / 2 + event.clientY) / 500;

        TweenMax.to('#wine-bottle', .5, {
          x: fgX,
          y: fgY
        });
        TweenMax.to('#wine-page-img-wrapper', .5, {
          x: bgX,
          y: bgY
        });
      });
    };

    Wines.prototype.previous = function() {
      currentWineIndex--;
      if (currentWineIndex < 0) {
        currentWineIndex = wineIds.length - 1;
      }
      switchWine(wineIds[currentWineIndex]);
    };

    Wines.prototype.next = function() {
      currentWineIndex++;
      if (currentWineIndex >= wineIds.length) {
        currentWineIndex = 0;
      }
      switchWine(wineIds[currentWineIndex]);
    };

    function switchWine(id) {
      var wineWrapperTemp = wineWrapper.clone()
      .attr('id', 'wine-temp')
      .insertAfter(wineWrapper);
      wineWrapper.css('opacity', 0);

      populatePage(id);

      TweenMax.to(wineWrapper, .5, { opacity: 1 });
      TweenMax.to(wineWrapperTemp, .5, {
        opacity: 0,
        onComplete: function() {
          wineWrapperTemp.remove();
        }
      });
    }

    function populatePage(id) {
      //var wine = _.find(Aneox.Data.Data.wines, { id: id });
      var wine = _.find(app.dataAllWines, { id: id });
      
      var tmpWineLocale = _.find(wine.locales, { locale: locale.getLocale() }); 
       
      wineDownloadButton.attr('href', 'pdf/wine/' + tmpWineLocale.nid);
      wineBottleElement.attr('src', wine.img);
      for (var detail in wine) {
        if (detail === 'name') {
          var name = wine[detail]
          .replace(wineNameRegex,
            '<span class="line-wrapper"><span class="line">$1</span></span>' +
            '<span class="line-wrapper"><span class="line">$2</span></span>' +
            '<span class="line-wrapper"><span class="line">$3</span></span>');
          $('#wine-name').html(name);
        } else if (detail === 'locales') {
          var wineLocale = _.find(wine[detail], { locale: locale.getLocale() });
          for (var localeDetail in wineLocale) {
            if (localeDetail !== 'name') {
              $('#wine-' + localeDetail).html(wineLocale[localeDetail]);
            }
          }
        } else {
            
          $('#wine-' + detail).html(wine[detail]);
        }
      }
      wineDetailsElement.mCustomScrollbar({
        scrollbarPosition: 'outside',
        scrollButtons: {
          enable: true,
          scrollType: 'stepped',
          scrollAmount: 200
        },
        callbacks: {
          onInit: function() {
            $(this).find('.mCSB_buttonUp').addClass('disabled');
          },
          onScroll: function() {
            if (this.mcs.topPct === 0) {
              $(this).find('.mCSB_buttonUp').addClass('disabled');
              $(this).find('.mCSB_buttonDown').removeClass('disabled');
            } else if (this.mcs.topPct === 100) {
              $(this).find('.mCSB_buttonDown').addClass('disabled');
              $(this).find('.mCSB_buttonUp').removeClass('disabled');
            } else {
              $(this).find('.mCSB_buttonUp, .mCSB_buttonDown').removeClass('disabled')
            }
          }
        }
      });
    }

    function emptyPage() {
      wineDetailsElement.mCustomScrollbar('destroy')
      .find('dd').html('');
    }

    function setPage(nodeId) {
      if (nodeId === router.getNode().id) return;
      
      var path = router.getNodePath(nodeId, locale.getLocale());
      if (path === undefined) return;

      router.setPath(path);
    }

    return Wines;
  })();

  Aneox.Wines = Wines;
})(Aneox || (Aneox = {}));